module.exports = __webpack_public_path__ + "static/YuliRios-0347b2bd7e7d166cebe283def2d15566.jpg";